import moment from 'moment-timezone';

const DefaultDateFormatISO = 'YYYY-MM-DDTHH:mm:ss';

export class DateTimeService {
  static offset: number;

  static setOffset = (value: number) => {
    DateTimeService.offset = value;
  };

  toServerDateTime = (date: string) => {
    return moment.utc(date).add(-DateTimeService.offset, 'hours').format(DefaultDateFormatISO);
  };

  toClientDateTime = (date: string) => {
    return moment.utc(date).add(DateTimeService.offset, 'hours').format(DefaultDateFormatISO);
  };
}

export const dateTimeService = new DateTimeService();
